import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-1/2 max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ...">
    <vx-card>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            label-placeholder="Number"
            @blur="$v.number.$touch()"
            v-model="number"
            :readonly="readonly"
          />
        </div>
      </div>
      <p v-if="$v.number.$error & $v.number.$dirty">Please Enter Required Data</p>

      <div class="vx-row mb-2">
        <div class="vx-col w-3/4">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="Importer"
            @blur="$v.importer.$touch()"
            v-model="importer"
          />
        </div>
      </div>
      <p v-if="$v.importer.$error & $v.importer.$dirty">Please Enter Required Data</p>

      <div class="vx-row mt-8">
        <div class="vx-col w-3/4">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Customer</span>
              </div>
            </template>
            <vs-select autocomplete v-model="customers_code" class="w-full">
              <vs-select-item
                v-for="customer in customers"
                :key="customer.code"
                :value="customer.code"
                :text="customer.ename"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <p
        v-if="$v.customers_code.$error & $v.customers_code.$dirty"
      >Please Enter Required Data with Correct Format</p>

      <div class="vx-row">
        <div class="vx-col w-1/2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>DCL Date</span>
              </div>
            </template>
            <datepicker format="yyyy-MM-dd" placeholder="วันที่นำเข้า" v-model="dcldate"></datepicker>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-1/2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>INB Date</span>
              </div>
            </template>
            <datepicker format="yyyy-MM-dd" placeholder="วันที่นำเข้าคลัง" v-model="inbdate"></datepicker>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-3/4">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Transport</span>
              </div>
            </template>
            <vs-select autocomplete v-model="transmode_id" class="w-full">
              <vs-select-item
                v-for="trans in transmode"
                :key="trans.id"
                :value="trans.id"
                :text="trans.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <p
        v-if="$v.transmode_id.$error & $v.transmode_id.$dirty"
      >Please Enter Required Data with Correct Format</p>

      <div class="vx-row mb-2">
        <div class="vx-col w-3/4">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link"
            icon-no-border
            label-placeholder="Carrier"
            v-model="vesselname"
            @blur="$v.vesselname.$touch()"
          />
        </div>
      </div>
      <p v-if="$v.vesselname.$error & $v.vesselname.$dirty">Please Enter Required Data</p>

      <div class="vx-row mb-2">
        <div class="vx-col w-3/4">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-list"
            icon-no-border
            label-placeholder="Remark"
            v-model="remark"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col 3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-eye"
            icon-no-border
            label-placeholder="Status"
            v-model="status"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-1/2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Status04</span>
              </div>
            </template>
            <datepicker format="yyyy-MM-dd" placeholder="วันที่ได้ Status04" v-model="status04"></datepicker>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSubmit" :disabled="$v.$anyError">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="clsd">Reset</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

import axios from "../axios_app";

export default {
  data() {
    return {
      number: "",
      importer: "",
      customers_code: "",
      transmode_id: "",
      vesselname: "",
      status04: "",
      dcldate: "",
      inbdate: "",
      remark: "",
      status: "",
      customers: [],
      transmode: [],
      readonly: false
    };
  },
  validations: {
    number: {
      required
    },
    importer: {
      required
    },
    customers_code: {
      required
    },
    vesselname: {
      required
    },
    transmode_id: {
      required
    }
  },
  components: {
    Datepicker
  },
  props: ["acstate", "recid"],
  methods: {
    clsd: function() {
      this.number = this.importer = this.customers_code = this.transmode_id = this.dcldate = this.inbdate = this.vesselname = this.remark = this.status04 =
        "";
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    onSubmit: function() {
      // alert("Hi");
      let vm = this;

      if (this.number == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter The Informaiton"
        });
        return;
      }

      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        comgroups_id: localStorage.getItem("comgroups_id"),
        number: this.number,
        importer: this.importer,
        customers_code: this.customers_code,
        dcldate: this.dcldate,
        inbdate: this.inbdate,
        transmode_id: this.transmode_id,
        vesselname: this.vesselname,
        remark: this.remark,
        status04: this.status04,
        acstate: this.acstate,
        recid: this.recid
      };

      // console.log(formData);
      axios
        .post("/ApiAddInborders", formData)
        .then(res => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: res.data.message,
              text: res.data.message
            });
          }
        })
        .catch(err => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err
          });
        });
      vm.$emit("grid");
      vm.clsd();
    }
  },
  beforeCreate() {
    // console.log("beforecreate");
    const formData = {
      token: localStorage.getItem("token"),
      token2: localStorage.getItem("token2"),
      dbname: localStorage.getItem("dbname")
    };

    axios
      .post("/ApiGetAddresssSelect", formData)
      .then(res => {
        // console.log(res);
        this.customers = res.data;
      })
      .catch(err => {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error",
          text: err
        });
      });

    axios
      .post("/ApiGetIntrans", formData)
      .then(res => {
        // console.log(res);
        this.transmode = res.data;
      })
      .catch(err => {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error",
          text: err
        });
      });
  },
  created() {
    // console.log(this.recid);
    // console.log("create");
    const formData = {
      token: localStorage.getItem("token"),
      token2: localStorage.getItem("token2"),
      dbname: localStorage.getItem("dbname"),
      id: this.recid
    };
    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;
      axios
        .post("/ApiGetInborder", formData)
        .then(res => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message
            });
          } else {
            this.number = res.data.message.number;
            this.importer = res.data.message.importer;
            this.customers_code = res.data.message.customers_code;
            this.dcldate = res.data.message.dcldate;
            this.inbdate = res.data.message.inbdate;
            this.transmode_id = res.data.message.transmode_id;
            this.vesselname = res.data.message.vesselname;
            this.remark = res.data.message.remark;
            this.status04 = res.data.message.status04;
            this.status = res.data.message.status;
          }
        })
        .catch(err => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err
          });
        });
    } else {
      let vm = this;
      vm.readonly = false;
      vm.clsd();
    }
  }
};
</script>

<style scoped>
p {
  color: red;
}
</style>
